
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchProduct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shop"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mimicCustomer"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CO_CustomerInput"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"translation"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CO_Product"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"shop"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shop"}}},{"kind":"Argument","name":{"kind":"Name","value":"mimicCustomer"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mimicCustomer"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductBase"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductSlots"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductMedia"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductSuppliers"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductCategories"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPropSet"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPropertyPivots"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductPrices"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductTranslations"},"directives":[]}]}}]}}],"loc":{"start":0,"end":596}};
    doc.loc.source = {"body":"#import \"../fragments/ProductSlots.gql\"\n#import \"../fragments/Product.gql\"\n\nquery FetchProduct($id: Int!, $shop: Int, $mimicCustomer: CO_CustomerInput, $translation: Boolean = false) {\n    CO_Product(id: $id, shop: $shop, mimicCustomer: $mimicCustomer) {\n        ...ProductBase\n        ...ProductSlots\n        ...ProductMedia\n        ...ProductSuppliers\n        ...ProductCategories\n        ...ProductPropSet\n        # ...ProductProperties\n        ...ProductPropertyPivots\n        ...ProductPrices\n        # ...ProductMainPrice\n        # ...ProductArticles\n        ...ProductTranslations\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("../fragments/ProductSlots.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("../fragments/Product.gql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["FetchProduct"] = oneQuery(doc, "FetchProduct");
        
